if( document.getElementById('custom-live-chat')) {
document.getElementById('custom-live-chat').onclick = function(e) {
    e.preventDefault(); 
    if(document.getElementById("dummy-chat-button-iframe")){ 
      document.getElementById("dummy-chat-button-iframe").contentWindow.document.getElementById("dummy-chat-button").addEventListener("click", dummyChatButtonIframe(), true);
    }else{
      document.getElementById("ShopifyChat").contentWindow.document.getElementsByClassName("chat-toggle")[0].addEventListener("click", ShopifyChat(), true);
    }
  }
}
function dummyChatButtonIframe() {
      var iframe = document.getElementById("dummy-chat-button-iframe");
      var elmnt  = iframe.contentWindow.document.getElementById("dummy-chat-button");
      elmnt.click(); 
}

function ShopifyChat() { 
  var iframe = document.getElementById("ShopifyChat");
  var elmnt = iframe.contentWindow.document.getElementsByClassName("chat-toggle")[0];
  elmnt.click();
}

class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.loadAsset()
  }
  loadAsset() {
    if(!document.querySelector('#slider-script')) {
      let sliderScript = document.createElement('script')
      sliderScript.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js')
      sliderScript.setAttribute('type', 'text/javascript')
      sliderScript.setAttribute('id', 'slider-script')
      document.head.appendChild(sliderScript);
    }
    this.assetInterval = setInterval(this.checkIfAssetisLoaded.bind(this), 1000)
  }
  checkIfAssetisLoaded() {
    if(typeof Swiper === 'function') {
      this.initSlider();
      clearInterval(this.assetInterval);
    }else {
      this.checkIfAssetisLoaded();
    }
  }
  initSlider() {
    let slideCountDesk = 4;
    if(this.dataset.slideCountDesk) {
      slideCountDesk = this.dataset.slideCountDesk;
    }
    this.slider = new Swiper(this, {
      slidesPerView: 1.5,
      loop: true,
      centeredSlides: true,
      navigation: {
        nextEl: '.carousel-button-next',
        prevEl: '.carousel-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          centeredSlides: false
        },
        800: {
          slidesPerView: 4,
          centeredSlides: false
        },
        1024: {
          slidesPerView: slideCountDesk,
          centeredSlides: false
        }
      }
    });
  }
}

customElements.define('product-carousel', ProductCarousel)

// class Testimonials extends HTMLElement {
//   constructor() {
//     super();
//     this.init();
//   }
//   init() {
//     this.assetInterval = setInterval(this.checkSwiperLoaded.bind(this), 1000)
//   }
//   checkSwiperLoaded() {
//     if(typeof Swiper === 'function') {
//       this.initSlider();
//       clearInterval(this.assetInterval);
//     }else {
//       this.checkSwiperLoaded();
//     }
//   }
//   initSlider() {
//     this.slider = new Swiper(this, {
//       loop: true,
//       slidesPerView: 1,
//       pagination: {
//         el: '.testimonial-pagination',
//       },
//       breakpoints: {
//         769: {
//           slidesPerView: 2
//         }
//       }
//     })
//   }
// }
// customElements.define('section-testimonials', Testimonials)

class ProductDeliveryAccordion extends HTMLElement {
  constructor() {
    super();
    this.btns = this.querySelectorAll('.Product_del_trigger');
    this.loadEvent()
  }
  loadEvent() {
    if(this.btns && this.btns.length > 0) {
      this.btns.forEach(btn => btn.addEventListener('click', this.handleClick.bind(this)), {useCapture: true})
    }
  }
  handleClick(e) {
    e.preventDefault();
    const id = e.target.dataset.id.trim()

    const content = document.getElementById(id)

    if(this.querySelectorAll('.Product_delivery_tabs_btn li') && this.querySelectorAll('.Product_delivery_tabs_btn li').length > 0) {
      this.querySelectorAll('.Product_delivery_tabs_btn li').forEach(l => l.classList.remove('tab-active'))
    }

    if(this.querySelectorAll('.Product_delivery_tab_content') && this.querySelectorAll('.Product_delivery_tab_content').length > 0) {
      this.querySelectorAll('.Product_delivery_tab_content').forEach(c => c.classList.remove('tab-active'))
    }

    if(content) content.classList.add('tab-active')
    e.target.parentNode.classList.add('tab-active')
  }
}
customElements.define('product-delivery-accordion', ProductDeliveryAccordion)
